module.exports = __webpack_public_path__ + "img/follow.ad310394.png";